module.exports = __webpack_public_path__ + "static/media/PM124.2de69982.png";